import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import MemberControlRight from '../../component/MemberControlRight';
import consts from '../../libs/consts';


import { getMemberinfo } from "../../utils/utils";


import * as APIS from "../../utils/service";
import Select from '../../component/Select';

export default function Membercontrol({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [memberinfos, setmemberinfos] = useState(''); 
    const [memberconinfo, setmemberconinfo] = useState(''); 
    
    const [lists, setlists] = useState([]); 
    const [selidx, setselidx] = useState('');   

    const levelText = ['','중개보조원','공인중개사','대표공인중개사'];


    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);


    useEffect(() => {
        listopen();
    }, []);
    const listopen = (flags='') => {
        dispatch(loadingflas({ loading: true }));
        let sender = {}
        APIS.postData('/v1/master/users', sender).then(({ data }) => {
            if(data){
                setlists(data);
                if(flags === 'nodata'){
                    setselidx(data[0]?.idx);
                    setmemberconinfo(data[0]);
                } else {
                    setselidx(selidx === '' ? data[0]?.idx : selidx);
                    setmemberconinfo(selidx === '' ? data[0] : data?.filter(item => item.idx === selidx)[0]);
                }

            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }


    return(
        <>
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={2} />
                </div>
                <div 
                    className='padding32'
                >
                    <div className='pagetitle fontsize20 bolds'>직원관리</div>

                    <div
                        className='margint20 membercontrolarea'
                    >
                        <div>
                            <div className="productlist_th">
                                <div style={{ width: 120}}>이름</div>
                                <div style={{ width: 60}}>직함</div>
                                <div style={{ width: 120}}>회원유형</div>
                                <div style={{ width: 120}}>공동중개 평가</div>
                                <div style={{ width: 20}}></div>
                            </div>
                            {lists?.length > 0 && lists?.map((x, i) => {
                                return (
                                    <div 
                                        key={i}
                                        className="productlist_td" 
                                        style={{ 
                                            border: selidx === x?.idx ? '1px solid #6164A5': '',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => {
                                            setselidx(x?.idx);
                                            setmemberconinfo(x);
                                            console.log(x);
                                        }}
                                    >
                                        <div style={{ width: 120, gap: 4}}>
                                            <div
                                                style={{
                                                    backgroundImage: `${x?.profile ? "url('"+ consts.s3url +"/"+ x?.profile +"')" : "url('./images/icons/user-3-fill-small.svg')"}`,
                                                    backgroundSize: `${x?.profile ? "cover" : ""}`,
                                                    width: 36, height: 36, border: '1px solid #EEE', borderRadius: 100, backgroundRepeat: 'no-repeat',
                                                    backgroundPosition: 'center'
                                                }}                                              
                                            />
                                            <span>{x?.name}</span>
                                        </div>
                                        <div style={{ width: 60}}>{x?.rank}</div>
                                        <div style={{ width: 120}}>{levelText[x?.level*1]}</div>
                                        <div style={{ width: 120}}>공동중개 평가</div>
                                        <div style={{ width: 20}}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M6.34868 2.01519C6.81359 1.55028 7.56736 1.55028 8.03227 2.01519L15.1751 9.15804C15.64 9.62295 15.64 10.3767 15.1751 10.8416L8.03227 17.9845C7.56736 18.4494 6.81359 18.4494 6.34868 17.9845C5.88377 17.5196 5.88377 16.7658 6.34868 16.3009L12.6497 9.99984L6.34868 3.69877C5.88377 3.23386 5.88377 2.4801 6.34868 2.01519Z" fill="#6164A5"/>
                                            </svg>                                    
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                        <div>
                            <MemberControlRight memberinfos={memberconinfo} listreflash={listopen} />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>

        </>
    )
}

